var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPfeilNachUnten = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "12 12 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "Pfeil-nach-unten_svg__cls-1",
  d: "M24.227 34.297c-.591-3.312-.405-7.231-.21-11.383.148-3.137.302-6.38.131-9.57l.998-.053c.174 3.24.02 6.509-.13 9.671-.193 4.093-.376 7.959.195 11.159l-.984.176Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "Pfeil-nach-unten_svg__cls-1",
  d: "M24.718 34.709h-.029c-.419-.026-1.532-.093-9.236-9.119l-.092-.107.76-.65.093.108c6.964 8.159 8.338 8.737 8.542 8.771.879-.257 5.216-6.23 7.034-9.17l.85.525c-.06.098-6.14 9.643-7.921 9.643Z"
})));
export default SvgPfeilNachUnten;